import React, { useEffect, useState } from "react";
import { LIST_MY_PROFILES, CREATE_PROFILE, EDIT_PROFILE } from "../API_LIST";
import matrimonyInstance from "../utils/axios";
import { getDataFromJwt, replaceIdInUrl, toastMaker } from "../utils/utility";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentProfile } from "../redux/features/authSlice";
import { setPaymentVisible } from "../redux/features/paymentSlice";
import { useNavigate } from "react-router-dom";

export default function EditProfile(props) {
	let navigate = useNavigate();

	const [isRequired, setIsRequired] = useState(false);
	const disPatch = useDispatch();
	const [userDetails, setUserDetails] = useState();
	const [profileData, setProfileData] = useState({
		first_name: props.isEdit ? props.userDetails?.first_name : "",
		last_name: props.isEdit ? props.userDetails?.last_name : "",
		relation_id: props.isEdit ? props.userDetails?.relation_id : "",
		profile: props.isEdit ? props.userDetails?.profile : "",
		birth_year: props.isEdit ? props.userDetails?.birth_year : "",
		birth_month: props.isEdit ? props.userDetails?.birth_month : "",
		gothram: props.isEdit ? props.userDetails?.gothram : "",
		birth_star: props.isEdit ? props.userDetails?.birth_star : "",
		lagna: props.isEdit ? props.userDetails?.lagna : "",
		place_of_birth: props.isEdit ? props.userDetails?.place_of_birth : "",
		time_of_birth: props.isEdit ? props.userDetails?.time_of_birth : "",
		height: props.isEdit ? props.userDetails?.height : "",
		weight: props.isEdit ? props.userDetails?.weight : "",
		education: props.isEdit ? props.userDetails?.education : "",
		resident_status: props.isEdit ? props.userDetails?.resident_status : "",
		profession: props.isEdit ? props.userDetails?.profession : "",
		current_employer: props.isEdit ? props.userDetails?.current_employer : "",
		current_location: props.isEdit ? props.userDetails?.current_location : "",
		siblings: props.isEdit ? props.userDetails?.siblings : "",
		mandatory_requirements: props.isEdit
			? props.userDetails?.mandatory_requirements
			: "",
		other_details: props.isEdit ? props.userDetails?.other_details : "",
	});

	const handleChange = (e) => {
		const { value, pattern } = e.target;

		if (pattern && value) {
			let regex = new RegExp(pattern);
			let result = regex.test(value);
			if (!result) return;
		}
		if (e.target.name === "relation_id") {
			setProfileData((prev) => {
				return { ...prev, [e.target.name]: parseInt(e.target.value) };
			});
		} else {
			setProfileData((prev) => {
				return { ...prev, [e.target.name]: e.target.value };
			});
		}
	};

	const createProfile = async (e) => {
		e.preventDefault();
		let roleId = getDataFromJwt("role");
		setIsRequired(true);
		if (
			profileData.first_name == "" ||
			profileData.last_name == "" ||
			profileData.relation_id == "" ||
			profileData.profile == "" ||
			profileData.birth_year == "" ||
			profileData.birth_month == "" ||
			profileData.gothram == "" ||
			profileData.birth_star == "" ||
			//profileData.lagna == "" ||
			profileData.place_of_birth == "" ||
			//profileData.time_of_birth == "" ||
			profileData.height == "" ||
			profileData.weight == "" ||
			//profileData.education == "" ||
			profileData.resident_status == "" ||
			profileData.profession == "" ||
			profileData.current_location == "" ||
			profileData.siblings == ""
			//profileData.mandatory_requirements == ""
		) {
			return toastMaker("Missing required fields", "error");
		}

		let data = profileData;
		data["bat_mm_account_id"] = props?.profilesData?.bat_mm_account_id || "";
		data["role_id"] = roleId;
		matrimonyInstance
			.post(CREATE_PROFILE, data)
			.then((response) => {
				toastMaker("Profile Created", "success");
				props.closeModal();
				if (response?.data?.profile.payment_status === "unpaid") {
					disPatch(setCurrentProfile(response?.data?.profile));
					disPatch(setPaymentVisible(true));
					navigate(
						`/dashboard/view-profile/${response?.data?.profile?.profile_id}`,
					);
				}
			})
			.catch((error) => {
				console.log("error");
				toastMaker(error, "Error");
			});
	};

	const editProfile = async (e) => {
		e.preventDefault();

		let data = profileData;

		const id = props?.userDetails?.profile_id;
		let url = replaceIdInUrl(EDIT_PROFILE, id);
		matrimonyInstance
			.put(url, data)
			.then((response) => {
				props.setUserDetails(response?.data?.profile);
				props.closeModal();
				toastMaker("Profile Data Updated", "success");
				disPatch(setCurrentProfile(response?.data?.profile));
			})
			.catch((error) => {
				console.log("error");
				toastMaker(error, "error");
			});
	};

	return (
		<div className="create-volunteer">
			<h4 className="text-center mb-30">
				{props?.isEdit ? "Edit Profile" : "Create Matrimony Profile"}
			</h4>
			<form onSubmit={props.isEdit ? editProfile : createProfile}>
				<div className="create-profile-fields-group">
					<div className="form-group mb-20">
						<label
							for="relation"
							className={
								isRequired &&
								profileData?.relation_id?.length == "" &&
								"color-red"
							}
						>
							Relation *
						</label>
						<select
							name="relation_id"
							value={profileData.relation_id}
							onChange={handleChange}
							id="relation"
							className="form-select rounded-1 mt-15"
						>
							<option value="" disabled>
								Select
							</option>
							<option value="1">Son</option>
							<option value="2">Daughter</option>
							<option value="3">Brother</option>
							<option value="4">Sister</option>
							<option value="5">Relative</option>
							<option value="6">Friend</option>
							<option value="7">Self</option>
						</select>
					</div>
					<div className="form-group mb-20">
						<label
							for="profile"
							className={
								isRequired && profileData?.profile?.length == "" && "color-red"
							}
						>
							Profile for *
						</label>
						<select
							name="profile"
							value={profileData.profile}
							onChange={handleChange}
							className="form-select rounded-1 mt-15"
						>
							<option value="" disabled>
								Select
							</option>
							<option value="bride">Bride</option>
							<option value="groom">Groom</option>
						</select>
					</div>
					<div className="form-group mb-20">
						<label
							className={
								isRequired &&
								profileData?.first_name?.length == "" &&
								"color-red"
							}
						>
							First Name *
						</label>
						<input
							type="text"
							className="form-control mt-10"
							name="first_name"
							pattern="^[a-zA-Z ]+$"
							value={profileData.first_name}
							onChange={handleChange}
						/>
					</div>
					<div className="form-group mb-20">
						<label
							className={
								isRequired &&
								profileData?.last_name?.length == "" &&
								"color-red"
							}
						>
							Last Name *
						</label>
						<input
							type="text"
							className="form-control mt-10"
							name="last_name"
							pattern="^[a-zA-Z ]+$"
							value={profileData.last_name}
							onChange={handleChange}
						/>
					</div>
					<div className="form-group mb-20">
						<label
							className={
								isRequired &&
								profileData?.birth_year?.length == "" &&
								"color-red"
							}
						>
							Birth Year *
						</label>
						<input
							type="number"
							className="form-control rounded-1 mt-10"
							name="birth_year"
							value={profileData.birth_year || ""}
							maxLength={4}
							onChange={(e) => {
								let value = e.target.value.replace(/\D/g, "");
								if (value.length > 4) return;

								handleChange({
									target: { name: "birth_year", value },
								});
							}}
							onBlur={(e) => {
								let value = parseInt(e.target.value, 10);
								const minYear = new Date().getFullYear() - 70 - 18;
								const maxYear = new Date().getFullYear() - 18;

								if (value < minYear) value = minYear;
								if (value > maxYear) value = maxYear;

								handleChange({
									target: { name: "birth_year", value },
								});
							}}
							min={new Date().getFullYear() - 70 - 18} // 70 years ago
							max={new Date().getFullYear() - 18} // 18 years old
							placeholder="Enter Birth Year"
						/>
					</div>
					<div className="form-group mb-20">
						<label
							for="birth_month"
							className={
								isRequired &&
								profileData?.birth_month?.length == "" &&
								"color-red"
							}
						>
							Birth Month *
						</label>
						<select
							name="birth_month"
							value={profileData.birth_month}
							onChange={handleChange}
							id="relation"
							className="form-select rounded-1 mt-10"
						>
							<option value="" disabled>
								Select
							</option>
							<option value="January">January</option>
							<option value="February">February</option>
							<option value="March">March</option>
							<option value="April">April</option>
							<option value="May">May</option>
							<option value="June">June</option>
							<option value="July">July</option>
							<option value="August">August</option>
							<option value="September">September</option>
							<option value="October">October</option>
							<option value="November">November</option>
							<option value="December">December</option>
						</select>
					</div>
					<div className="form-group mb-20">
						<label
							className={
								isRequired && profileData?.gothram?.length == "" && "color-red"
							}
						>
							Gotram *
						</label>
						<input
							type="text"
							className="form-control mt-10"
							name="gothram"
							pattern="^[a-zA-Z ]+$"
							value={profileData.gothram}
							onChange={handleChange}
						/>
					</div>
					<div className="form-group mb-20">
						<label
							className={
								isRequired &&
								profileData?.birth_star?.length == "" &&
								"color-red"
							}
						>
							Birth Star (Janma Nakshatram) *
						</label>
						<input
							type="text"
							className="form-control mt-10"
							name="birth_star"
							pattern="^[a-zA-Z ]+$"
							value={profileData.birth_star}
							onChange={handleChange}
						/>
					</div>
					<div className="form-group mb-20">
						<label>Lagna (Janma Lagnam)</label>
						<input
							type="text"
							className="form-control mt-10"
							name="lagna"
							pattern="^[a-zA-Z ]+$"
							value={profileData.lagna}
							onChange={handleChange}
						/>
					</div>
					<div className="form-group mb-20">
						<label
							className={
								isRequired &&
								profileData?.place_of_birth?.length == "" &&
								"color-red"
							}
						>
							Place of Birth *
						</label>
						<input
							type="text"
							className="form-control mt-10"
							name="place_of_birth"
							pattern="^[a-zA-Z ]+$"
							value={profileData.place_of_birth}
							onChange={handleChange}
						/>
					</div>
					<div className="form-group mb-20">
						<label>Time of Birth</label>
						<input
							type="text"
							className="form-control mt-10"
							name="time_of_birth"
							value={profileData.time_of_birth}
							onChange={handleChange}
						/>
					</div>
					<div className="form-group mb-20">
						<label
							className={
								isRequired && profileData?.height?.length == "" && "color-red"
							}
						>
							Height *
						</label>
						<input
							type="text"
							className="form-control mt-10"
							name="height"
							value={profileData.height}
							onChange={handleChange}
						/>
					</div>
					<div className="form-group mb-20">
						<label
							className={
								isRequired && profileData?.weight?.length == "" && "color-red"
							}
						>
							Weight *
						</label>
						<input
							type="text"
							className="form-control mt-10"
							name="weight"
							value={profileData.weight}
							onChange={handleChange}
						/>
					</div>
					<div className="form-group mb-20">
						<label>Education & School</label>
						<input
							type="text"
							className="form-control mt-10"
							name="education"
							pattern="^[a-zA-Z ]+$"
							value={profileData.education}
							onChange={handleChange}
						/>
					</div>
					<div className="form-group mb-20">
						<label
							for="resident_status"
							className={
								isRequired &&
								profileData?.resident_status?.length == "" &&
								"color-red"
							}
						>
							Resident Status *
						</label>
						<select
							name="resident_status"
							value={profileData.resident_status}
							onChange={handleChange}
							id="relation"
							className="form-select rounded-1 mt-10"
						>
							<option value="" disabled>
								Select
							</option>
							<option value="US Citizen">US Citizen</option>
							<option value="US Permanent Resident / Green card holder">
								US Permanent Resident / Green card holder
							</option>
							<option value="Indian Citizen on F1 visa (student)">
								Indian Citizen on F1 visa (student)
							</option>
							<option value="Indian Citizen on H1-B visa with EAD">
								Indian Citizen on H1-B visa with EAD
							</option>
							<option value="Indian Citizen on H1-B visa with approved I-140">
								Indian Citizen on H1-B visa with approved I-140
							</option>
							<option value="Indian Citizen on H1-B visa">
								Indian Citizen on H1-B visa
							</option>
							<option value="Indian Citizen on L1 visa">
								Indian Citizen on L1 visa
							</option>
						</select>
					</div>
					<div className="form-group mb-20">
						<label
							className={
								isRequired &&
								profileData?.profession?.length == "" &&
								"color-red"
							}
						>
							Profession *
						</label>
						<input
							type="text"
							className="form-control mt-10"
							name="profession"
							pattern="^[a-zA-Z ]+$"
							value={profileData.profession}
							onChange={handleChange}
						/>
					</div>
					<div className="form-group mb-20">
						<label>Current Employer</label>
						<input
							type="text"
							className="form-control mt-10"
							name="current_employer"
							pattern="^[a-zA-Z ]+$"
							value={profileData.current_employer}
							onChange={handleChange}
						/>
					</div>
					<div className="form-group mb-20">
						<label
							className={
								isRequired &&
								profileData?.current_location?.length == "" &&
								"color-red"
							}
						>
							Current Location *
						</label>
						<input
							type="text"
							className="form-control mt-10"
							name="current_location"
							pattern="^[a-zA-Z ]+$"
							value={profileData.current_location}
							onChange={handleChange}
						/>
					</div>
					<div className="form-group mb-20">
						<label
							className={
								isRequired && profileData?.siblings?.length == "" && "color-red"
							}
						>
							Siblings *
						</label>
						<select
							name="siblings"
							value={profileData.siblings}
							onChange={handleChange}
							className="form-select rounded-1 mt-10"
						>
							<option value="" disabled>
								Select
							</option>
							<option value="0">0</option>
							<option value="1">1</option>
							<option value="2">2</option>
							<option value="3">3</option>
							<option value="4">4</option>
							<option value="5">5</option>
						</select>
					</div>
					<div className="form-group mb-20">
						<label>Mandatory Requirements</label>
						<input
							type="text"
							className="form-control mt-10"
							name="mandatory_requirements"
							value={profileData.mandatory_requirements}
							onChange={handleChange}
						/>
					</div>
				</div>
				<div className="form-group mb-20">
					<label className="mb-10">Other Details</label>
					<textarea
						type="text"
						className="form-control"
						name="other_details"
						value={profileData.other_details}
						onChange={handleChange}
					/>
				</div>
				<button
					type="submit"
					className="btn mb-25"
					onClick={props.isEdit ? editProfile : createProfile}
				>
					Submit
				</button>
			</form>
		</div>
	);
}
